import React, { useContext, useState } from 'react'
import imageWafaCashMaroc from '../../assets/imageWafaCashMaroc.svg'
import imageMulual from '../../assets/imageMulual.svg'
import imageBOP from '../../assets/imageBOP.png'
import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'
import UserContext from 'contexts/UserContext'
import ModalTestStatusUser from 'components/modalTestStatusUser'

  const ReseauList=[
   {paysValue:'MAD', reseau: 'Wafacash', value:'Wafacash', logo:imageWafaCashMaroc},
   {paysValue:'PKR', reseau: 'Pakistan Cash Pick-up (BoP Agents)', value:'de la Bank of Punjab', logo:imageBOP},
   {paysValue:'BDT', reseau: 'Mutual Trust Bank', value:' de la Mutual Trust Bank', logo:imageMulual},
  ]

interface props {
  setNumStep: (value: number) => void
  setNetworkChecked: (value: string) => void
  functionTracks: any
  valuePays:string
}
const PointDeCollectMaroc: React.FC<props> = ({
  setNumStep,
  setNetworkChecked,
  functionTracks, valuePays
}) => {
  const { user } = useContext(UserContext)


  const partner=ReseauList.find((item)=>item.paysValue===valuePays)

  const statusComplete = user?.user?.status === 'confirmed' && user?.user?.isDocumentSent
  const statusPending = user?.user?.status === 'pending' && user?.user?.isDocumentSent
  const statusNotFound = user?.user?.status === 'pending' && !user?.user?.isDocumentSent

  const navigate = useNavigate()

  const [openIsModalStatus, setOpenIsModalStatus] = useState(false)

 
  const openModalStatus = () => {
    setOpenIsModalStatus(true)
  }
   const closeModalStatus = () => {
    setOpenIsModalStatus(false)
  }

  return (
    <div className="">
      
        <div className="h2">Point de retrait</div>
        <div className="text-[#6B7280] text-[14px] font-normal mt-[13px]"> Votre bénéficiaire peut récupérer l&apos;argent dans n&apos;importe quelle agence {partner?.value}. </div>
        <div className="flex flex-col items-center justify-center gap-3 mx-auto my-[25px] sm:my-[40px] border-2 border-[#5653E4] rounded-[16px] p-5 w-[200px]">
          <img src={partner?.logo} alt={partner?.reseau} />
          <div className={`w-8 h-8 rounded-full text-[#FFF]  bg-[#5653E4] flex items-center justify-center`}> ✔ </div>
        </div>
     

      <div className="flex  gap-[16px] justify-center w-full  font-roboto font-bold text-[16px]">
        <button
          className={classNames(' text-[#5754E5]  h-[56px]  border border-[#5754E5] w-[180px] sm:w-[120px]  rounded-[16px]' )}
          onClick={() => {
            setNumStep(1)
          }}
        >
          Précédent
        </button>

        <button
          className={classNames(
            ' text-[#FFF] bg-[#5754E5] h-[56px] hover:cursor-pointer  w-[375px] sm:w-[207px] rounded-[16px]',
          )}
          onClick={() => {
            if (statusComplete) {
              setNumStep(3)
              setNetworkChecked(partner?.reseau || '')
              functionTracks('3')
            } else if (statusPending) {
              openModalStatus()
            } else if (statusNotFound) {
              navigate('/personalinformation')
            }
          }}
        >
          Suivant
        </button>
      </div>
      <ModalTestStatusUser
        isOpen={openIsModalStatus}
        closeModal={closeModalStatus}
        statusPending={statusPending}
        statusNotFound={statusNotFound}
      />
    </div>
  )
}

export default PointDeCollectMaroc
